import { Formik, FormikHelpers } from 'formik';

import { dateFormatter } from 'commons/utils';
import { ENTITY_STATUS_AUDITS } from 'commons/constants/status';
import { cpfMask } from 'commons/utils/masks';
import { TYPES_FIGURANT } from 'commons/constants/figurants';
import { changeStatusEntity } from 'services/figurantServices';
import { showSnackbar } from '../Snackbar/actionSnackbar';
import { Button, LoadingButton, TextField } from '../../elements';
import { CustomDialog } from '../Dialog';

import { validationSchema } from './validationSchema';

import { IInitialValues, IChangeStatusFigurantModal } from './@types';

import * as S from './styles';

export const ChangeStatusFigurantModal = ({
  isOpen,
  onClose,
  item,
  callback = () => {},
}: IChangeStatusFigurantModal) => {
  const initialValues: IInitialValues = {
    description: '',
  };

  const onSubmit = async (values: IInitialValues, { setSubmitting }: FormikHelpers<IInitialValues>) => {
    setSubmitting(true);

    const status = item?.isActive ? 'deactivate' : 'activate';

    const payload = {
      entityId: item.id,
      description: values.description,
      entityType: item.entityType,
    };

    await changeStatusEntity({ status, payload })
      .then(() => {
        showSnackbar('success', 'Ação realizada com sucesso!');
        onClose();
        callback();
      })
      .catch((error: any) => {
        showSnackbar('error', error?.response?.data?.Message || 'Error ao tentar realizar ação!');
      });

    setSubmitting(false);
  };

  const blockedData = item.entityStatusAudits
    .filter(item => item.status === ENTITY_STATUS_AUDITS.BLOQUEADO)
    .sort((a, b) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime())[0];

  const entityName = {
    [TYPES_FIGURANT.ANIMAL]: 'animal',
    [TYPES_FIGURANT.FISCAL]: 'fiscal',
    [TYPES_FIGURANT.VEICULO]: 'veículo',
  };

  const name = entityName[item.entityType] || 'figurante';
  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={onClose}
      title={
        <S.Title>
          Deseja <strong>{item?.isActive ? 'bloquear' : 'desbloquear'}</strong> o {name}?
        </S.Title>
      }
      description={
        <S.Content>
          <S.Description>
            {item?.title} | {item?.subTitle}
            <br />
            <>{cpfMask(item?.document)}</>
          </S.Description>
          {!item.isActive && (
            <S.Reason>
              <strong>Figurante bloqueado em {dateFormatter(blockedData?.creationTime)}</strong>
              <br />
              <strong>Motivo:</strong> {blockedData?.description}
            </S.Reason>
          )}
        </S.Content>
      }
    >
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema} validateOnMount>
        {({ isSubmitting, handleChange, errors, touched, handleBlur }) => (
          <S.Form>
            <TextField
              name="description"
              variant="outlined"
              label="Insira uma observação*"
              error={!!touched.description && !!errors.description}
              multiline
              rows={4}
              onChange={handleChange}
              helperText={touched.description && errors.description}
              FormHelperTextProps={{ sx: { ml: 0 } }}
              onBlur={handleBlur}
            />
            <S.ButtonsWrapper>
              <Button width="93px" variant="outlined" onClick={() => onClose()} disabled={isSubmitting}>
                Cancelar
              </Button>
              <LoadingButton $maxWidth="118px" loading={isSubmitting} type="submit">
                {item?.isActive ? 'Bloquear' : 'Desbloquear'}
              </LoadingButton>
            </S.ButtonsWrapper>
          </S.Form>
        )}
      </Formik>
    </CustomDialog>
  );
};
